<template>
  <div class="brandIncreasePage">
    <div class="banner">
      <img src="../../assets/images/brandIncrease_banner.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">商务&销售管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">合作品牌管理</div>
    </div>

    <div class="input_box search flex-between">
      <van-field
        v-model="keyword"
        ref="input"
        placeholder="输入品牌关键字查找→"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.enter="handleSearch"
      />
      <div class="search_btn flex-rowr" @click="handleSearch">
        <i class="iconfont icon-sousuo"></i>
      </div>
    </div>
    <div class="input_tip flex-rowc">
      <span>请查看搜索结果</span>
      <div class="btn" @click="handleSearch">显示全部</div>
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="title">
            <h2>品牌名称：</h2>
            <p>{{ item.labelname ? item.labelname : item.labelcont }}</p>
            <p v-if="item.labelcont_e">{{ item.labelcont_e }}</p>
            <p v-if="item.labelcont_y">{{ item.labelcont_y }}</p>
            <p v-if="item.labelcont_m">{{ item.labelcont_m }}</p>
            <p v-if="item.labelcont_t">{{ item.labelcont_t }}</p>
          </div>
          <div class="img">
            <img :src="item.logo" alt="" />
          </div>
          <div class="txt1">
            状态：{{ item.labelstate == 1 ? "启用" : "停用" }}
          </div>
          <div class="txt1">所属企业：{{ item.qyname }}</div>
          <div class="txt2">
            添加日期：<span>{{ item.createdate | formatDate }}</span>
          </div>
          <div class="txt2">
            操作人员：<span>{{ item.createman }}</span>
          </div>
          <div class="edit" @click="handleGo(item.id)">编辑品牌信息→</div>
        </div>
      </div>

      <div class="noData" v-else>
        <p>尚未添加合作品牌</p>
      </div>
      <!-- <div class="return-fixd flex-rowc" v-if="isShowTabbar">
        <div class="primary-button" @click="handleGo()">+新增合作品牌</div>
        <div class="default-button" @click="handleReturn">返回</div>
      </div> -->
    </div>

    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleGo()">新增合作品牌</div>
    </div>
    <!-- <Tabbar v-if="isShowTabbar"></Tabbar> -->
  </div>
</template>

<script>
import { getMenuAuthTwo, getBrandList, encryptstringadd } from "../../api/api";
// import Tabbar from "../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "brandList",
  // components: {
  //   Tabbar,
  // },
  data() {
    return {
      isShowTabbar: true,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      keyword: "",
      qyid: 0,
      qyguid: 0,

      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyguid = userInfo.qy.qyguid;
    } else {
      this.qyguid = 0;
    }
    this.roleId = userInfo.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
    this.init();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    // 搜索
    handleSearch() {
      this.init();
    },
    init() {
      let { keyword, qyguid } = this;
      getBrandList({ keyword, qyguid }).then((res) => {
        let dataNew = res;
        dataNew.forEach((v) => {
          if (v.logo && v.logo.indexOf("http") == -1) {
            v.logo = "/Upload/" + v.logo;
          }
        });
        // 按时间降序
        // dataNew.sort((a, b) => b.createdate.localeCompare(a.createdate));
        this.dataList = dataNew;
      });
    },

    handleReturn() {
      history.back();
    },
    handleGo(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }

      if (id) {
        // this.$router.push({ path: "/brandIndex/brandDetail", query: { id } });
        this.encryptstringadd("brandDetail", { id });
      } else {
        // this.$router.push({ path: "/brandIndex/brandDetail" });
        this.encryptstringadd("brandDetail", "");
      }
    },
    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  padding-bottom: 400px;
  .input_box.search {
    padding: 0 30px 0 35px;
    margin-bottom: 30px;
    .search_btn {
      width: 60px;
    }
  }
  .input_tip {
    font-size: 14px;
    margin-bottom: 60px;
    color: #aaaaaa;
    .btn {
      margin-left: 30px;
      background: #6e5c86;
      color: #fff;
      padding: 0 15px;
      height: 40px;
      line-height: 40px;
      font-size: 12px;
      border-radius: 5px;
    }
  }
  .noData p {
    text-align: center;
    font-size: 28px;
    color: #aaaaaa;
    padding: 150px 0;
  }
  .item_card {
    width: 650px;
    margin: 0 auto 60px;
    padding: 45px 37px 100px;
    position: relative;
    border: 2px solid #dedede;
    border-radius: 30px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .title {
      font-size: 30px;
      color: #404d6c;
      p {
        font-size: 22px;
        margin-top: 20px;
      }
    }
    .img {
      width: 250px;
      height: 250px;
      margin: 80px auto 50px;
      overflow: hidden;
      background: #fbf8ef;
      img {
        width: 100%;
      }
    }
    .txt1 {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 26px;
      color: #444444;
      font-weight: bold;
      margin-bottom: 10px;
      span {
        font-size: 26px;
        color: #f40728;
        font-weight: 400;
      }
    }
    .edit {
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #6e5c86;
      border-radius: 25px;
      font-size: 20px;
      color: #fff;
      position: absolute;
      bottom: 30px;
      right: 20px;
    }
  }
}
</style>